import { Link } from "react-router-dom";
import { Phone, Mail, Instagram, Globe, MapPin, ShieldCheck, Lock } from "lucide-react";

export const Footer = () => (
  <footer data-testid="main-footer" className="relative border-t border-white/[0.07] bg-[#0a0e17]/80 backdrop-blur-xl">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <span className="font-display text-2xl font-semibold">Gromza<span className="text-amber-400">.</span></span>
          <p className="mt-4 text-sm text-slate-400 leading-relaxed">
            India's B2B + B2C commerce OS. Sell everywhere. From the next lane to the next state.
          </p>
        </div>

        <div>
          <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-amber-400 mb-5">Explore</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li><a data-testid="footer-link-storefront" href="/#storefront" className="hover:text-amber-400 transition-colors">Digital Storefront</a></li>
            <li><a data-testid="footer-link-command-center" href="/#command-center" className="hover:text-amber-400 transition-colors">Command Center</a></li>
            <li><a data-testid="footer-link-growth" href="/#growth" className="hover:text-amber-400 transition-colors">Growth Engine</a></li>
            <li><a data-testid="footer-link-customers" href="/#customers" className="hover:text-amber-400 transition-colors">For Customers</a></li>
            <li><Link data-testid="footer-link-privacy" to="/privacy" className="hover:text-amber-400 transition-colors">Privacy Policy</Link></li>
            <li>
              <Link data-testid="footer-link-admin" to="/admin" className="inline-flex items-center gap-1.5 hover:text-amber-400 transition-colors">
                <Lock size={12} /> Admin Portal
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-amber-400 mb-5">Contact</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex items-center gap-2.5">
              <Phone size={14} className="text-amber-400 shrink-0" />
              <a data-testid="footer-phone-link" href="tel:+918651938731" className="hover:text-amber-400 transition-colors">+91 8651938731</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Instagram size={14} className="text-amber-400 shrink-0" />
              <a data-testid="footer-instagram-link" href="https://instagram.com/gromza_1" target="_blank" rel="noreferrer" className="hover:text-amber-400 transition-colors">@gromzashopping</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Globe size={14} className="text-amber-400 shrink-0" />
              <a data-testid="footer-website-link" href="https://gromza.com" target="_blank" rel="noreferrer" className="hover:text-amber-400 transition-colors">www.gromza.com</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Mail size={14} className="text-amber-400 shrink-0" />
              <a data-testid="footer-email-link" href="mailto:akashkumar8651.ak@gmail.com" className="hover:text-amber-400 transition-colors break-all">akashkumar8651.ak@gmail.com</a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-amber-400 mb-5">Grievance Officer</h4>
          <ul className="space-y-3 text-sm text-slate-400" data-testid="footer-grievance-info">
            <li className="flex items-center gap-2.5">
              <ShieldCheck size={14} className="text-amber-400 shrink-0" /> Akash Kumar
            </li>
            <li className="flex items-center gap-2.5">
              <MapPin size={14} className="text-amber-400 shrink-0" /> Patna, Bihar, India
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/[0.06] flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-slate-500" data-testid="footer-copyright">
          © {new Date().getFullYear()} Gromza. All rights reserved.
        </p>
        <p className="text-xs text-slate-500">Your favourite shops. Best offers. Better shopping.</p>
      </div>
    </div>
  </footer>
);
